// ── NotificationCountContext.js ───────────────────────────────────────────────
// Context يوزّع عدادات الإشعارات على كل مكونات الموقع
// ─────────────────────────────────────────────────────────────────────────────

import React, { createContext, useContext } from "react";
import useNotificationCounts from "./useNotificationCounts";

const NotificationCountContext = createContext({
  counts:     {},
  markSeen:   () => {},
  totalUser:  0,
  totalAdmin: 0,
  chatTotal:  0,
  isOwner:    false,
});

export const NotificationCountProvider = ({ currentUser, children }) => {
  const notifData = useNotificationCounts(currentUser);
  return (
    <NotificationCountContext.Provider value={notifData}>
      {children}
    </NotificationCountContext.Provider>
  );
};

export const useNotifCounts = () => useContext(NotificationCountContext);

export default NotificationCountContext;
